<template>
  <nav class="fixed top-0 left-0 w-full z-50 bg-[#222222] shadow font-berthold-force uppercase">
    <div
      class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4"
    >
      <a
        class="flex items-center space-x-3 rtl:space-x-reverse"
        href="/auth"
      >
        <img
          :src="appLogo"
          class="h-8"
          alt="CombateOne"
        />
      </a>

      <!-- mobile open -->
      <button
        data-collapse-toggle="navbar-default"
        type="button"
        class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
        aria-controls="navbar-default"
        aria-expanded="false"
      >
        <span class="sr-only">Open main menu</span>
        <svg
          class="w-5 h-5"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 17 14"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M1 1h15M1 7h15M1 13h15"
          />
        </svg>
      </button>

      <div class="hidden w-full md:block md:w-auto" id="navbar-default">
        <ul
          class="font-medium flex flex-col p-4 md:p-0 mt-4 border rounded-lg md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0"
        >
          <li>
            <router-link
              :to="{ name: 'home' }"
              class="block py-2 px-3 tracking-wider rounded-sm md:border-0 md:p-0"
              :class="[
                menuActive == 'inicio' ? 'text-[#d20a0a] hover:text-[#972c2c] font-semibold' : 'text-white hover:text-[#d20a0a]'
              ]"
            >
              inicio
          </router-link>
          </li>

          <li>
            <router-link
              :to="{ name: 'prog' }"
              class="block py-2 px-3 tracking-wider rounded-sm md:border-0 md:p-0"
              :class="[
                menuActive == 'progresso' ? 'text-[#d20a0a] hover:text-[#972c2c] font-semibold' : 'text-white hover:text-[#d20a0a]'
              ]"
            >
              progresso
            </router-link>
          </li>

          <li>
            <router-link
              :to="{ name: 'cert' }"
              class="block py-2 px-3 tracking-wider rounded-sm md:border-0 md:p-0"
              :class="[
                menuActive == 'certificados' ? 'text-[#d20a0a] hover:text-[#972c2c] font-semibold' : 'text-white hover:text-[#d20a0a]'
              ]"
            >
              certificados
            </router-link>
          </li>

          <li>
            <router-link
              :to="{ name: 'coll' }"
              class="block py-2 px-3 tracking-wider rounded-sm md:border-20a0a] md:p-0"
              :class="[
                menuActive == 'colecao' ? 'text-[#d20a0a] hover:text-[#972c2c] font-semibold' : 'text-white hover:text-[#d20a0a]'
              ]"
            >
              cursos
            </router-link>
          </li>

          <li>
            <router-link
              :to="{ name: 'prof' }"
              class="block py-2 px-3 tracking-wider rounded-sm md:border-0 md:p-0"
              :class="[
                menuActive == 'perfil' ? 'text-[#d20a0a] hover:text-[#972c2c] font-semibold' : 'text-white hover:text-[#d20a0a]'
              ]"
            >
              perfil
            </router-link>
          </li>

        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { dataShared } from '@/shared/store'
import { computed } from 'vue'

const menuActive = computed(() => dataShared.getters.getMenuActive)
const appLogo = computed(() => dataShared.getters.getAppLogo)

</script>
